<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-25 16:11:31
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 19:18:57
-->
<template>
	<div class="home main-content-padding">
		<div class="alert" v-if="expireHint.length && $auth.hasPermi('system:ImmediateRenewal')">
			<i class="iconfont icon-a-warningjinggao-mian"></i>
			<p class="ml-8 mr-16">
				{{ expireHint[0] }}
				<template v-if="expireHint[1]">
					<span class="day">{{ residue_day }}</span
					>{{ expireHint[1] }}
				</template>
			</p>
			<el-button v-if="$auth.hasPermi('system:ImmediateRenewal')" type="primary" @click="showExpireDialog">立即续费</el-button>
			<expire-dialog :expire-hint="expireHint" :residue-day="residue_day" :qr-code="service.service_qr" ref="expireDialog" />
		</div>
		<Panel :style="stickyStyle" class="mb-16" :class="[isFixed ? 'pos-fix' : 'pos-normal']" :contentPaddingTop="2" :contentPaddingBottom="12">
			<platform-tab @change="handlePlatformClick" :platformId="platformId" showAll class="flex-1 platformTab"></platform-tab>
			<div class="flex-row-align-center" v-show="showPlatformContent">
				<div class="flex-row-align-center">
					<div style="width: 50px" class="text-align-right fz-14" />
					<partnerOrdept ref="partnerOrdept" :userIds="userIds" :deptIds="deptIds" @change="detSearch" @changeType="changeType" />
				</div>
				<div class="flex-row-align-center">
					<div style="width: 120px" class="text-align-right fz-14 mr-6"> 团长 </div>
					<commander-select
						style="width: 250px"
						ref="commanderSelect"
						class="ml-8"
						:key="platformId"
						:platformId="platformId"
						v-model="authorityId"
						@change="
							() => {
								getData('all');
							}
						"
					></commander-select>
				</div>

				<div class="flex-row-align-center">
					<div style="width: 120px" class="text-align-right fz-14"> 时间 </div>
					<quickTimePicker class="ml-8" :cycle="62" :value="30" :cuttentMaxDay="180" showMoreCuttent ref="blockTimePicker" @change="handleChange">
					</quickTimePicker>
				</div>
			</div>
		</Panel>
		<div v-if="isFixed" style="height: 110px"></div>
		<div class="flex-row" v-show="showPlatformContent">
			<div class="flex-1 mr-16">
				<!--        数据概览-->
				<dataOverview
					v-if="$auth.hasPermi('partner-result:home-data-overview-bench')"
					ref="dataOverview"
					:platformId="platformId"
					:userIds="userIds"
					:deptIds="deptIds"
					:authorityId="authorityId"
					:params="params"
				/>
				<div class="flex-row flex-wrap">
					<!--          旧版转化-->
					<legacyConversion
						v-for="item in conversionList"
						:key="item"
						:showKey="item"
						ref="legacyConversion"
						:deptIds="deptIds"
						:authorityId="authorityId"
						:platformId="platformId"
					/>
					<!-- 达人转化 -->
					<conversionDr
						v-if="showConversionDr"
						ref="ConversionDr"
						:userIds="userIds"
						:deptIds="deptIds"
						:authorityId="authorityId"
						:platformId="platformId"
						:params="params"
					/>
					<!-- 样品转化 -->
					<conversionSample
						v-if="$auth.hasPermi('home:product-conversion')"
						ref="ConversionSample"
						:userIds="userIds"
						:deptIds="deptIds"
						:authorityId="authorityId"
						:platformId="platformId"
						:params="params"
					/>
					<!--        排行榜-->
					<variousLeaderboards
						ref="variousLeaderboards"
						v-for="item in rankList"
						:key="item"
						:showKey="item"
						:userIds="userIds"
						:deptIds="deptIds"
						:authorityId="authorityId"
						:platformId="platformId"
						:params="params"
					/>
				</div>
			</div>
			<div class="homePage_aside">
				<!--        数据大屏-->
				<largeScreenEntrance v-if="showDataScreen && $auth.hasPermi('home:largeScreen-entrance')" :link="dataScreenUrl"></largeScreenEntrance>
				<!--				 待办事项 -->
				<Backlog
					ref="Backlog"
					v-if="$auth.hasPermi('partner-result:home-work-bench')"
					:userIds="userIds"
					:deptIds="deptIds"
					:authorityId="authorityId"
					:platformId="platformId"
					:params="params"
				/>
				<!--				  日历-->
				<calendar v-if="$auth.hasPermi('home:calendar-view')" :key="authorityId" :id="authorityId" ref="calendar"></calendar>
				<!--				  公告-->
				<announcement ref="announcement" :userIds="userIds" :deptIds="deptIds" :platformId="platformId" />
			</div>
		</div>
		<auth-alert-dialog ref="authAlertDialog"></auth-alert-dialog>
		<authStatusResult ref="authStatusResult"></authStatusResult>
		<Notice ref="notice"></Notice>
	</div>
</template>

<script>
import partnerOrdept from '@/components/business/partnerOrdept';
import quickTimePicker from '@/components/ui/quickTimePicker';
import dataOverview from './components/contentLeft/dataOverview';
import legacyConversion from './components/contentLeft/legacyConversion';
import conversionDr from './components/contentLeft/conversion/conversionDr';
import conversionSample from './components/contentLeft/conversion/conversionSample';
import variousLeaderboards from './components/contentLeft/variousLeaderboards';
import Backlog from './components/asideRight/backlog';
import announcement from './components/asideRight/announcement';
import expireDialog from './components/expireDialog';
import mixin from '@/mixins';
import calendar from './components/calendar.vue';
import largeScreenEntrance from './components/largeScreenEntrance.vue';
import { getHomeLoginInfo, getAuthStatus, getScreenInfo } from '@/api/home';
import { mapGetters } from 'vuex';
import { AUTH_RESULT_STATUS_REPEAT_SUCCESS, AUTH_RESULT_STATUS_ARR } from '@/utils/dataMap';
import authStatusResult from '@/modules/auth/authStatusResult.vue';
import AuthAlertDialog from '@/modules/auth/alert';
import authMixin from '@/modules/auth/mixin';
import commanderSelect from '@/components/commanderSelect/index.vue';
import { platformMixin } from '@rd/rd-ui';
export default {
	name: 'home',
	mixins: [mixin, authMixin, platformMixin],
	components: {
		partnerOrdept,
		quickTimePicker,
		dataOverview,
		legacyConversion,
		conversionDr,
		conversionSample,
		variousLeaderboards,
		Backlog,
		announcement,
		expireDialog,
		calendar,
		authStatusResult,
		AuthAlertDialog,
		Notice: () => import('./components/notice'),
		largeScreenEntrance,
		commanderSelect,
	},
	computed: {
		...mapGetters(['defaultPlatform', 'isShopPartnerDataView', 'onlyZsPartnerTag', 'isPersonDataScope']),
		expireHint() {
			const { expire_status, residue_day } = this;
			let hints = [];
			if (expire_status) {
				hints = ['您系统已到期，请尽快联系销售续费以免影响正常使用'];
			} else {
				if (!residue_day) return [];
				hints = ['您订购的服务还剩 ', ' 天到期，为了不影响使用，请尽快联系客服或销售续费'];
			}
			return hints;
		},
		authStatus() {
			//0成功1失败
			return +this.$route.query.status;
		},
		isAuthStatusSuccess() {
			//0成功1失败
			return +this.authStatus === AUTH_RESULT_STATUS_REPEAT_SUCCESS;
		},
		authPlatformId() {
			//授权回调平台
			return this.$route.query.platform_id;
		},
		stickyStyle() {
			const { baseTop } = this.getBase;
			if (this.stickyOpt == 0) {
				return {
					boxShadow: '4px 4px 4px rgb(0,0,0,0.06)',
					top: 64 + 'px',
					left: 0,
					right: 0,
					width: 'auto',
					minWidth: '1408px',
					borderRadius: 0,
					zIndex: '2001',
					borderTop: '1px solid #f0f1f5',
				};
			}
			return {
				top: 64 + baseTop - this.scrollTop + 'px',
				left: this.stickyOpt + 'px',
				right: this.stickyOpt + 'px',
				zIndex: '2001',
				width: 'auto',
				minWidth: '1408px',
			};
		},
		getBase() {
			let passLine = 0;
			let baseTop = 16;
			if (this.expireHint.length && this.$auth.hasPermi('system:ImmediateRenewal')) {
				baseTop += 60;
				passLine += 60;
			}
			return { passLine, baseTop };
		},
		showConversionDr() {
			return (
				this.$auth.hasPermi('home:anchor-conversion') &&
				this.authorityId === '' &&
				!this.isShopPartnerDataView &&
				!(this.onlyZsPartnerTag && this.isPersonDataScope)
			);
		},
		conversionList() {
			const conversion = ['anchor', 'product'];
			return conversion.filter(item => this.$auth.hasPermi(`home:${item}-data-view`));
		},
	},
	data() {
		return {
			userIds: [],
			deptIds: [],
			params: {
				from_time: '',
				to_time: '',
			},
			authorityId: '',
			scrollTop: 0,
			stickyOpt: 16,
			isFixed: false,
			service: {},
			expire_status: false,
			residue_day: '',
			platformId: dataMap.PLATFORM_ALL.value,
			showDataScreen: false,
			dataScreenUrl: '',
			borderColor: '',
			rankList: ['RankingDr', 'RankingGood', 'RankingRc', 'RankingStaff'],
			defaultAllPlatformId: dataMap.PLATFORM_ALL.value,
		};
	},
	watch: {
		defaultPlatform(n) {
			this.$nextTick(() => {
				if (!n) {
					return;
				}
				this.platformId = n;
				this.getData();
			});
		},
	},
	mounted() {
		this.params.from_time = this.$refs['blockTimePicker'].start_time;
		this.params.to_time = this.$refs['blockTimePicker'].end_time;
		this.$nextTick(() => {
			this.getData('all');
			// 授权返回首页
			const { isAuthStatusSuccess, authPlatformId, authStatus } = this;
			if (AUTH_RESULT_STATUS_ARR.includes(authStatus)) {
				this.$refs.authStatusResult.show(isAuthStatusSuccess, authPlatformId, '', this.authStatus);
			}
			this.getAuthStatus();
			document.querySelector('.el-main').addEventListener('scroll', this.stickyFn);
		});
	},
	beforeDestroy() {
		document.querySelector('.el-main')?.removeEventListener('scroll', this.stickyFn);
	},
	methods: {
		// 切平台
		handlePlatformClick(val) {
			this.platformId = val;
			this.userIds = [];
			this.deptIds = [];
			this.authorityId = '';
			this.$refs?.['partnerOrdept']?.reset?.();
			this.$refs?.['commanderSelect']?.reset?.();
			this.service = {};
			this.getData();
		},
		stickyFn(e) {
			const { passLine } = this.getBase;
			if (e.target.scrollTop <= Number(passLine) && this.isFixed) {
				this.isFixed = false;
			}
			if (e.target.scrollTop > Number(passLine) && !this.isFixed) {
				this.isFixed = true;
			}
			this.scrollTop = e.target.scrollTop;

			if (e.target.scrollTop - passLine < 0) {
				if (this.stickyOpt != 16) {
					this.stickyOpt = 16;
				}
				return;
			}
			if (e.target.scrollTop - passLine <= 16) {
				this.stickyOpt = 16 - (e.target.scrollTop - passLine);
			}
			if (e.target.scrollTop - passLine > 16 && this.stickyOpt != 0) {
				this.stickyOpt = 0;
			}
		},
		// 部门/员工筛选
		detSearch(value, type) {
			if (type) {
				this.userIds = value;
				this.deptIds = [];
			} else {
				this.userIds = [];
				this.deptIds = value;
			}
			this.getData();
		},
		// 切换员工与部门的时候 如果切换前有数据 则切换后 需要重置数据
		changeType() {
			this.userIds = [];
			this.deptIds = [];
		},
		// 时间筛选
		handleChange({ start_time, end_time }) {
			this.params = {
				from_time: start_time,
				to_time: end_time,
			};
		},
		// 团长、平台、部门切换时触发刷新登录信息、大屏信息、日历信息，其他模块在组件内刷新
		getData(type = 'all') {
			this.getHomeLoginInfo();
			this.$nextTick(_ => {
				this.$refs.announcement.getAnnouncementList();
				// 获取大屏信息
				if (type === 'all') {
					this.getScreenInfo();
					setTimeout(() => {
						this.$refs.calendar.calendarList(new Date(), this.authorityId);
						this.$refs.calendar.calendarDetail(new Date(), this.authorityId);
					});
				}
			});
		},

		async getAuthStatus() {
			const { auth, newAuth, isManager } = await getAuthStatus();
			// 全部平台当中抖音
			const temPF = {
				[dataMap.PLATFORM_DY.value]: dataMap.PLATFORM_DY.value,
				[dataMap.PLATFORM_KS.value]: dataMap.PLATFORM_KS.value,
				[dataMap.PLATFORM_SP.value]: dataMap.PLATFORM_SP.value,
				[dataMap.PLATFORM_ALL.value]: dataMap.PLATFORM_DY.value,
			};
			if (!auth) return; //未授权
			if (newAuth) return; //是否授权新应用
			if (isManager) {
				this.checkAuth(temPF[this.platformId]); //管理员弹窗
			} else {
				this.$refs.notice.show(); //通知
			}
		},
		// 获取登录信息
		async getHomeLoginInfo() {
			const { code, data: { service = {}, expire_status = false, residue_day = '' } = {} } = await getHomeLoginInfo({
				platform_id: this.platformId,
				deptIds: this.deptIds,
				authority_id: this.authorityId,
			});
			if (code !== 0) return;
			this.service = service;
			this.expire_status = expire_status;
			this.residue_day = residue_day;
		},
		showExpireDialog() {
			this.$refs.expireDialog.show();
		},
		async getScreenInfo() {
			const { showDataScreen = false, dataScreenUrl = '' } = await getScreenInfo();
			this.showDataScreen = showDataScreen;
			this.dataScreenUrl = dataScreenUrl;
		},
	},
};
</script>
<style lang="less">
.platformTab .el-tabs__header {
	margin-bottom: 12px !important;
}
.service-popover {
	padding: 12px;

	.el-image {
		width: 150px;
		height: 150px;
		background-color: #f5f5f5;
	}

	.text {
		margin-top: 16px;
		font-size: 14px;
		color: #666;
		text-align: center;
	}
}
</style>
<style lang="less" scoped>
.home {
	.pos-normal {
		position: unset;
	}
	color: #333;
	// background-color: #f5f5f5;
	padding-bottom: 16px;
	.homePage_aside {
		width: 320px;
	}
	.homePage_inlinet {
		width: 50%;
		box-sizing: border-box;
		margin-top: 16px;

		&:nth-child(odd) {
			padding-right: 8px;
		}

		&:nth-child(even) {
			padding-left: 8px;
		}
	}
	.alert {
		height: 48px;
		border-radius: 2px;
		border: 1px solid #fdd2a1;
		margin-bottom: 16px;
		background-color: #fef3e7;
		display: flex;
		align-items: center;
		padding-left: 16px;
		font-size: 14px;

		.iconfont {
			color: #ed6a0c;
		}

		.day {
			font-weight: bold;
			color: #fa8f14;
		}
	}
}
</style>
